/*
* <div class="alert-wrap">
        <div class="alert-mian">这里是文字，随便什么文字</div>
        <div class="alert-footer">
            <div class="alert-ok">确定</div>
            <div class="alert-no">取消</div>
        </div>
    </div>
* */

class Elem {
  constructor() {
    this.getElem();
  }

  getElem() {
    this.dom = document.getElementById('sk-alert');
    if (!this.dom) {
      const a = this.createDiv('sk-alert');
      a.id = 'sk-alert';
      this.asyncAppend(a);
    } else {
      this.initEvent();
    }
  }

  asyncAppend(el) {
    if (document.body) {
      document.body.appendChild(el);
      this.dom = document.getElementById('sk-alert');
      this.initEvent();
    } else {
      setTimeout(() => {
        this.asyncAppend(el);
      }, 500);
    }
  }
  initEvent(){
    this.addEvent(this.dom, 'mousewheel');
    this.addEvent(this.dom, 'touchmove');
    this.addEvent(this.dom, 'DOMMouseScroll');
    this.getWrap();
  }
  getWrap() {
    this.wrap = this.dom.querySelector('.alert-wrap');
    if (!this.wrap) {
      const a = this.createDiv('alert-wrap');
      this.dom.appendChild(a);
      this.wrap = this.dom.querySelector('.alert-wrap');
    }
  }

  addEvent(dom, type) {
    dom.addEventListener(type, this.prevent, false);
  }

  prevent(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }

  createDiv(c) {
    const dom = document.createElement('div');
    if (c) {
      dom.className = c;
    }
    return dom;
  }

  createChild(html, ocn, ncn, sett) {
    const main = this.createDiv('alert-mian');
    const footer = this.createDiv('alert-footer');
    const ok = this.createDiv('alert-ok');
    main.innerHTML = html;
    this.wrap.appendChild(main);
    ok.innerHTML = sett.ok || '确定';
    ok.onclick = () => {
      ocn();
    };
    footer.appendChild(ok);
    if(sett.confirm === 1){
      const no = this.createDiv('alert-no');
      no.innerHTML = sett.no || '取消';
      no.onclick = () => {
        ncn();
      };
      footer.appendChild(no);
    }
    this.wrap.appendChild(footer);
  }

  merge(html, ocn, ncn, sett) {
    this.wrap.innerHTML = '';
    this.createChild(html, ocn, ncn, sett);
  }

  show() {
    this.dom.style.display = 'block';
    setTimeout(() => {
      this.wrap.style.opacity = 1;
      this.wrap.style.transform = 'translateX(-50%) translateY(-50%)';
    }, 0);

  }

  hide(cn) {
    this.wrap.style.opacity = 0;
    this.wrap.style.transform = 'translateX(-50%) translateY(-100%)';
    setTimeout(() => {
      this.dom.style.display = 'none';
      cn();
    }, 200);
  }
}

export {Elem};